import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Pagination from "../Pagination/Pagination";
import './style.css';

class Loading extends Component {
    render() {
        return (
            <div>
                <div className="Loading">
                    <div className="sk-cube-grid">
                        <div className="sk-cube sk-cube1"/>
                        <div className="sk-cube sk-cube2"/>
                        <div className="sk-cube sk-cube3"/>
                        <div className="sk-cube sk-cube4"/>
                        <div className="sk-cube sk-cube5"/>
                        <div className="sk-cube sk-cube6"/>
                        <div className="sk-cube sk-cube7"/>
                        <div className="sk-cube sk-cube8"/>
                        <div className="sk-cube sk-cube9"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/Components/Loading/Loading.jsx